<template>
  <section class="t-mt-8">
    <div class="t-flex t-items-center" role="heading">
      <h2 class="t-text-2xl t-font-medium t-text-gray-900 t-mb-1 t-inline-block">
        On Site Trackers
      </h2>
      <span v-tooltip="`These are the Freightmates trackers that are at your default pickup location. It would be great if you could reuse, recycle or return these Freightmates so they can assist you or other Freighthub customers.`">
        <i class="fa fa-question-circle d-inline" aria-hidden="true" style="margin-left: 0.25rem; white-space: pre-line"/>
      </span>
    </div>

    <div
      v-if="isLoadingOnSite"
      class="t-mt-8 t-flex t-justify-center"
    >
      <p class="t-text-2xl">Loading Trackers...</p>
    </div>

    <div
      v-if="!isLoadingOnSite && !onSiteTrackers.length"
      class="t-mt-8 t-flex t-justify-center"
    >
      <p class="t-text-1xl">No Trackers Set Yet</p>
    </div>

    <base-tracking-table
      v-show="!isLoadingOnSite && onSiteTrackers.length"
      :trackers="onSiteTrackers"
      :column-headers="onSiteColumnHeaders"
    >
      <template #booking="{ bookingId }">
        <div class="t-text-sm lg:t-py-4">
          <div class="t-grid t-grid-rows-1 t-grid-cols-2 t-visible t-block md:t-hidden">
            <p>Recent Booking</p>
            <p>{{ bookingId }}</p>
          </div>
          <p class="t-hidden md:t-block">
            {{ bookingId }}
          </p>
        </div>
      </template>

      <template #options>
        <div class="t-flex-row t-text-sm t-space-y-2 t-text-center t-items-center lg:t-flex-col lg:t-my-2">
          <button
            class="t-px-1 t-text-center t-rounded-md t-text-blue-600 t-font-medium"
            @click="setModalInfo(modalReuseInfo)"
          >
            Reuse
          </button>
          <button
            class="t-px-1 t-text-center t-rounded-md t-text-blue-600 t-font-medium"
            @click="setModalInfo(modalRecycleInfo)"
          >
            Recycle
          </button>
          <button
            class="t-px-1 t-text-center t-rounded-md t-text-blue-600 t-font-medium"
            @click="setModalInfo(modalReturnInfo)"
          >
            Return
          </button>
        </div>
      </template>
    </base-tracking-table>

    <modal
      v-if="modal.isShowing"
      @closed="modal.isShowing = !modal.isShowing"
    >
      <template #title>
        <div class="t-text-xl t-font-medium">
          {{ modal.title }}
        </div>
      </template>
      <template>
        <p class="t-p-4 t-tracking-wide">
          {{ modal.text }}
        </p>
      </template>
    </modal>
  </section>
</template>

<script>
import BaseTrackingTable from "./BaseTrackingTable";
import Modal from "../../utils/Modal";

export default {
  name: 'OnSiteTrackersTab',
  components: {
    BaseTrackingTable,
    Modal
  },
  props: {
    mapRawTrackers: {
      type: Function, required: true
    }
  },
  data() {
    return {
      onSiteTrackers: [],
      isLoadingOnSite: false,
      onSiteColumnHeaders: ['Freightmate', 'Last Detected', 'Last Movement', 'Recent Booking', '', ''],
      modal: {
        isShowing: false,
        title: '',
        text: ''
      }
    }
  },
  created() {
    this.loadUnlinkedOnSite();

    this.modalReuseInfo = {
      title: 'How To Reuse',
      text: 'If you send freight, reuse this tracker by placing a booking and attaching the tracker to your freight. Real-time tracking is free if your freight is sent with Freighthub, or $5 (+GST) for freight send with other carriers.'
    };
    this.modalRecycleInfo = {
      title: 'How To Recycle',
      text: 'This tracking device can be gifted to any business that sends Business to Business freight. Let them experience the convenience of knowing where their freight is at all times.'
    };
    this.modalReturnInfo = {
      title: 'How To Return',
      text: `If you can't reuse or recycle this tracker, please return it to Freighthub free of charge by dropping it as-is into any post box (no packaging required). Thanks!`
    };
  },
  methods: {
    async loadUnlinkedOnSite() {
      try {
        this.isLoadingOnSite = true;
        let res = await axios.get('/send-freight/tracker/unlink/onsite');
        let data = Object.values(await res.data);
        this.onSiteTrackers = this.mapRawTrackers(data);
      } catch (e) {
        console.error(e);
      } finally {
        this.isLoadingOnSite = false;
      }
    },
    setModalInfo(modalInfo) {
      this.modal.title = modalInfo.title;
      this.modal.text = modalInfo.text;
      this.modal.isShowing = true;
    }
  }
}
</script>

<style scoped>
p {
  margin: 0;
}
</style>
